import { INSTALLMENT_STATUS } from '../constants/financial';

const sumCents = (installments) =>
  installments.reduce((sum, i) => sum + Math.round((Number(i.value) || 0) * 100), 0);

const isPending = (i) => i.status !== INSTALLMENT_STATUS.PAGO;

// Rótulo exibido na coluna "Plano de Contas" da linha agrupada.
const groupLabel = (document, count) => {
  if (document) return `${document} — rateio em ${count} contas`;
  return `Rateio da OS em ${count} contas`;
};

// Monta a linha unificada de uma cobrança de OS (parcelas de mesmo número,
// uma por categoria). O shape espelha o de uma parcela crua — a tabela, a
// ordenação e a impressão do Contas a Receber leem os mesmos campos.
const buildGroupRow = (children) => {
  const first = children[0];
  const pending = children.filter(isPending);
  const allPaid = pending.length === 0;
  const dueDates = (allPaid ? children : pending).map((i) => i.due_date).filter(Boolean);
  const paymentDates = children.map((i) => i.payment_date).filter(Boolean);

  const entry = first.financial_entry || {};
  const osId = entry.order_service_id;

  const paidPaymentDate = paymentDates.length > 0 ? paymentDates.sort().slice(-1)[0] : null;

  return {
    id: `os-${osId}-${first.installment_number}`,
    isGroup: true,
    children,
    installment_number: first.installment_number,
    value: sumCents(children) / 100,
    pendingValue: sumCents(pending) / 100,
    status: allPaid ? INSTALLMENT_STATUS.PAGO : INSTALLMENT_STATUS.PENDENTE,
    due_date: dueDates.length > 0 ? dueDates.sort()[0] : first.due_date,
    payment_date: allPaid ? paidPaymentDate : null,
    bank_id: pending.length > 0 ? pending[0].bank_id : null,
    financial_entry: {
      ...entry,
      AccountPlan: { name: groupLabel(entry.document, children.length) },
    },
  };
};

// Agrupa as parcelas do Contas a Receber para exibição: parcelas de lançamentos
// que compartilham a mesma OS (order_service_id) e o mesmo número de parcela
// viram 1 linha com o valor somado (cobrança unificada). Parcelas manuais (sem
// OS) passam intactas. Não altera dados — o rateio por categoria continua no
// banco para a DRE.
export const groupReceivableRows = (installments) => {
  const groups = new Map();
  const slots = [];

  installments.forEach((installment) => {
    const osId = installment.financial_entry?.order_service_id;
    if (!osId) {
      slots.push(installment);
      return;
    }
    const key = `os-${osId}-${installment.installment_number}`;
    if (!groups.has(key)) {
      groups.set(key, []);
      slots.push(key);
    }
    groups.get(key).push(installment);
  });

  return slots.map((slot) => {
    if (typeof slot !== 'string') return slot;
    const children = groups.get(slot);
    if (children.length === 1) return children[0];
    return buildGroupRow(children);
  });
};
